import { ArrowDown } from "lucide-react";
import { Link } from "react-router-dom";

export default function PageHero({
  eyebrow = "The Bridge by VA",
  title,
  copy,
  children,
}) {
  return (
    <section className="relative overflow-hidden bg-ink pb-20 pt-36 text-white lg:pb-28 lg:pt-44">
      <div className="tech-grid absolute inset-0 opacity-60" />
      <div className="absolute -right-32 top-8 h-80 w-80 rounded-full bg-ocean/20 blur-[100px]" />
      <div className="absolute bottom-0 left-1/4 h-48 w-48 rounded-full bg-bridge/10 blur-[90px]" />
      <div className="container relative">
        <p className="eyebrow text-cyan">{eyebrow}</p>
        <h1 className="mt-5 max-w-4xl font-display text-4xl font-extrabold leading-[1.02] tracking-[-.055em] sm:text-6xl lg:text-7xl">
          {title}
        </h1>
        {copy && (
          <p className="mt-6 max-w-2xl text-base leading-8 text-slate-300 sm:text-lg">
            {copy}
          </p>
        )}
        {children}
        <Link
          to="#content"
          className="mt-10 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-cyan hover:text-white"
        >
          Explore <ArrowDown size={14} />
        </Link>
      </div>
    </section>
  );
}
